export default __webpack_public_path__ + "static/media/inbox-icon.17fbb6be.svg";